<template>
  <v-dialog v-model="dialog" persistent max-width="450px">
    <v-card grid-list-md>
      <ModelTitle title="New Zakat Allocation" @close="close()" />
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12">
            <v-autocomplete dense autofocus :hide-details="CustomerIdErrors.length === 0"
              :error-messages="CustomerIdErrors" :items="Customers" clearable item-text="name"
              v-model="selectedCustomer" return-object item-value="id" label="Select Customer" outlined>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12">
            <v-autocomplete dense :hide-details="StudentIdErrors.length === 0" :error-messages="StudentIdErrors"
              :items="Students" clearable item-text="fullName" v-model="ZakatAllocation.StudentId" item-value="id"
              label="Select Student" outlined>
            </v-autocomplete>
          </v-col>
          <v-col cols="6" sm="6">
            <DateSelector label="Start Date" v-model="ZakatAllocation.startDate"
              :hide-details="startDateErrors.length === 0" :error-messages="startDateErrors" />
          </v-col>
          <v-col cols="6" sm="6">
            <DateSelector label="Exp Date" :initValue="ZakatAllocation.endDate" v-model="ZakatAllocation.endDate"
              :hide-details="endDateErrors.length === 0" :error-messages="endDateErrors" />
          </v-col>
          <v-col cols="12" sm="12">
            <v-text-field type="number" :hide-details="AmountErrors.length === 0" :error-messages="AmountErrors"  dense outlined class="right-input" label="Amount"
              v-model="ZakatAllocation.amount"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text="text" @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="submit()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import zakatAllocationService from "../service.js";
import DateSelector from "@/components/DateSelector";
import customerService from "@/modules/Customer/service.js";
import studentService from "@/modules/Student/service.js";


const { validationMixin } = require("vuelidate");
const { required, minValue } = require("vuelidate/lib/validators");

export default {
  props: {
    createDialog: {
      default: false,
    },
  },
  name: "create-zakatAllocation",
  data() {
    return {
      loading: false,
      dialog: false,
      Customers: [],
      selectedCustomer: null,
      Students: [],
      ZakatAllocation: {
        startDate: this.$moment().toISOString(),
        endDate: this.$moment().add(1, 'year').toISOString(),
        amount: 0,
        CustomerId: null,
        StudentId: null,
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    ZakatAllocation: {
      startDate: {
        required,
      },
      endDate: {
        required,
      },
      CustomerId: {
        required,
      },
      StudentId: {
        required,
      },
      amount: {
        required,
        minValue: minValue(1)  // Ensures amount is greater than 0
      }
    },
  },
  components: {
    DateSelector
  },
  computed: {
    startDateErrors() {
      const errors = [];
      if (!this.$v.ZakatAllocation.startDate.$dirty) return errors;
      if (!this.$v.ZakatAllocation.startDate.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    endDateErrors() {
      const errors = [];
      if (!this.$v.ZakatAllocation.endDate.$dirty) return errors;
      if (!this.$v.ZakatAllocation.endDate.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    CustomerIdErrors() {
      const errors = [];
      if (!this.$v.ZakatAllocation.CustomerId.$dirty) return errors;
      if (!this.$v.ZakatAllocation.CustomerId.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    StudentIdErrors() {
      const errors = [];
      if (!this.$v.ZakatAllocation.StudentId.$dirty) return errors;
      if (!this.$v.ZakatAllocation.StudentId.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    AmountErrors() {
      const errors = [];
      if (!this.$v.ZakatAllocation.amount.$dirty) return errors;
      if (!this.$v.ZakatAllocation.amount.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.ZakatAllocation.amount.minValue)
        errors.push('Amount must be greater than zero');
      return errors;
    },
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
      if (val) {

        this.getCustomers()
      }
    },
    selectedCustomer(val) {
      if (val) {
        this.getStudents(val.id)
        this.ZakatAllocation.CustomerId = val.id
        this.ZakatAllocation.StudentId = null
      }
    },
  },
  methods: {
    getCustomers() {
      return customerService.getAll().then((response) => {
        this.Customers = response.data;
        console.log("response Customers", this.Customers);

        return response;
      });
    },
    getStudents(customerId) {
      return studentService.getAll({ CustomerId: customerId }).then((response) => {
        this.Students = response.data;
        console.log("response Students", this.Students);

        return response;
      });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.ZakatAllocation = {
        startDate: this.$moment().toISOString(),
        endDate: this.$moment().add(1, 'year').toISOString(),
        amount: 0,
        CustomerId: null,
        StudentId: null,
      };
      this.Customers = [],
        this.selectedCustomer = null,
        this.Students = [],
        this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        if (!this.$moment(this.ZakatAllocation.endDate).isAfter(this.$moment(this.ZakatAllocation.startDate))) {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: "End date should be after Start Date",
            });
          return true
        }
        this.loading = true;
        return zakatAllocationService
          .create(this.ZakatAllocation)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "ZakatAllocation is created",
                });
              this.empty();
              this.loading = false;
              this.$emit("submit");
            }
          })
          .catch((err) => {
            console.log("error", err);
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
